import BudgetRequest from './budget-request';
import InvoiceRequest from './invoice-request';
import PaymentsRequest from './payments-request';
import NotificationRequest from './notifications-request';
import AuthRequest from './auth-request';
import OrderRequest from './order-request';

export default {
  ...BudgetRequest,
  ...InvoiceRequest,
  ...PaymentsRequest,
  ...NotificationRequest,
  ...AuthRequest,
  ...OrderRequest,
};
